import axios from 'axios';

/**
 * MenuService - Centralized menu loading for course navigation
 *
 * This service provides a consistent way to load menu data across all components,
 * replacing the old pattern of adding ?menu=true to various endpoints.
 */
class MenuService {
    /**
     * Load menu data for a specific course
     * @param {number} courseId - The course ID
     * @returns {Promise<Object>} - Menu data from the dedicated menu endpoint
     */
    async loadCourseMenu(courseId) {
        try {
            const response = await axios.get(`/api/courses/${courseId}/menu?append=completed`);
            return response.data;
        } catch (error) {
            console.error('Failed to load course menu:', error);
            throw error;
        }
    }

    /**
     * Load menu data and dispatch to Vuex store
     * @param {Object} store - Vuex store instance
     * @param {number} courseId - The course ID
     * @returns {Promise<Object>} - Menu data
     */
    async loadAndSetCourseMenu(store, courseId) {
        const menuData = await this.loadCourseMenu(courseId);
        await store.dispatch('Menu/setMenuForCourse', menuData, { root: true });
        return menuData;
    }

    /**
     * Legacy method for backward compatibility
     * @deprecated Use loadAndSetCourseMenu instead
     */
    async loadCourseWithMenu(courseId) {
        console.warn('MenuService.loadCourseWithMenu is deprecated. Use loadAndSetCourseMenu instead.');
        return this.loadCourseMenu(courseId);
    }
}

export default new MenuService();
